import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as eduActions from 'modules/edu';
import { Icon, Label } from 'semantic-ui-react';
import { reduxForm, Field, change } from 'redux-form';

import {
  ReduxFormMaterialTextField,
  ReduxFormSemanticDropdown,
  ModalTemplate,
  Button as Btn,
  Loading
} from 'components';

import classNames from 'classnames/bind';
import styles from './EduQuiz.css';
const cx = classNames.bind(styles);

class EduQuizAddEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eduContentsOption: [],
      eduFileOption: [],
      loading: false
    };
  }

  componentDidMount() {
    this.props.initialize();
    this.setDefaultForm();
  }

  componentDidUpdate(prevProps) {
    const { isModal } = this.props;
    // 모달 닫힐 시 formStore 초기화
    if (!isModal) {
      this.props.initialize();
    }

    // 모달 열릴 시 초기값 설정
    if (prevProps.isModal !== isModal) {
      if (isModal === 'eduQuizAdd') {
        // 퀴즈 등록일 경우
        const initialValue = {
          quizContent: '',
          quizSolution: '',
          eduAttachNo: 0,
          fileNo: 0
        };
        this.props.initialize(initialValue);
      } else if (isModal === 'eduQuizEdit') {
        // 퀴즈 수정일 경우
        this.setDefaultForm();
      }
    }
  }

  // 퀴즈 수정일 경우 해당 퀴즈 값 세팅
  setDefaultForm = () => {
    this.setState({ loading: true });
    const { quizRowInfo, eduAttachByAttachNo } = this.props;

    // 컨텐츠
    let defaultAttachNo = 0;
    const tempAttachOption = [];
    eduAttachByAttachNo.map((data, index) => {
      data.get('fileInfo').map(file => {
        if (file.get('fileNo') === quizRowInfo.fileNo) {
          defaultAttachNo = data.get('eduAttachNo');
        }
      });
      tempAttachOption.push({ key: index, value: data.get('eduAttachNo'), text: data.get('attachName') });
    });

    // 교육 영상
    let defaultFileNo = 0;
    const tempFileOption = [];
    eduAttachByAttachNo.map(data => {
      if (data.get('eduAttachNo') === defaultAttachNo) {
        defaultFileNo = quizRowInfo.fileNo;
        const selectedContents = eduAttachByAttachNo.find(data => data.get('eduAttachNo') === defaultAttachNo);
        selectedContents && selectedContents.get('fileInfo').map((info, index) => {
          tempFileOption.push({ key: index, value: info.get('fileNo'), text: info.get('fileName') });
        });
      }
    });

    const initialValue = {
      quizContent: quizRowInfo.quizContent,
      quizSolution: quizRowInfo.quizSolution,
      eduAttachNo: defaultAttachNo,
      fileNo: defaultFileNo
    };
    this.props.initialize(initialValue);

    this.setState({
      eduContentsOption: tempAttachOption,
      eduFileOption: tempFileOption,
      loading: false
    });
  };

  // 퀴즈 등록 이벤트 처리
  postEduQuiz = async () => {
    // todo: validation 처리
    this.setState({ loading: true });
    const { EduActions, onToggleModal, formStore } = this.props; //toggleDeleteModal,
    try {
      const formValue = formStore && formStore.values;
      const params = {
        // quizType: formValue.quizType,
        quizType: 1,
        quizContent: formValue.quizContent,
        quizSolution: parseInt(formValue.quizSolution),
        fileNo: formValue.fileNo
      };

      await EduActions.postEduQuiz(params);
    } catch (e) {
      console.log(e);
    }

    this.setState({ loading: false });
    onToggleModal('');
  };

  // 퀴즈 수정 이벤트 처리
  putEduQuiz = async () => {
    this.setState({ loading: true });
    const { EduActions, onToggleModal, formStore, quizRowInfo } = this.props;
    try {
      const formValue = formStore && formStore.values;
      const formInitial = formStore && formStore.initial;
      const params = {
        quizNo: quizRowInfo.quizNo
      };

      // 초기값과 달라진 항목만 파라미터에 추가
      if (formValue.quizContent !== formInitial.quizContent) {
        params['quizContent'] = formValue.quizContent;
      }
      if (formValue.quizSolution !== formInitial.quizSolution) {
        params['quizSolution'] = formValue.quizSolution;
      }
      if (formValue.fileNo !== formInitial.fileNo) {
        params['fileNo'] = formValue.fileNo;
      }

      await EduActions.putEduQuiz(params);
    } catch (e) {
      console.log(e);
    }

    this.setState({ loading: false });
    onToggleModal('');
  };

  // 컨텐츠 변경 시 해당 컨텐츠에 따라 교육 영상 옵션 변경
  handleChangeContents = (e, eduAttachNo) => {
    const { eduAttachByAttachNo } = this.props;

    const tempFileOption = [];
    const selectedContents = eduAttachByAttachNo.find(data => data.get('eduAttachNo') === eduAttachNo);
    if (selectedContents) {
      selectedContents.get('fileInfo').map((info, index) => {
        tempFileOption.push({ key: index, value: info.get('fileNo'), text: info.get('fileName') });
      });
    }
    this.setState({
      ...this.state,
      eduFileOption: tempFileOption
    });

    //  컨텐츠 변경 시 교육 영상 선택값 초기화
    this.props.change('fileNo', 0);
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { formStore, onToggleModal, isModal } = this.props;
    const { eduContentsOption, eduFileOption, loading } = this.state;
    const { postEduQuiz, putEduQuiz, handleChangeContents } = this;

    // 퀴즈 유형 선택 옵션
    // const quizTypeOption = [
    //   {
    //     key: 1,
    //     value: 1,
    //     text: defineMessages(formatMessage({ id: 'Quiz_6', defaultMessage: '진위형' }))
    //   },
    //   {
    //     key: 2,
    //     value: 2,
    //     text: defineMessages(formatMessage({ id: 'Quiz_7', defaultMessage: '선다형' }))
    //   }
    // ];

    // 정답 선택 옵션
    const quizSolutionOption = [
      {
        key: 1,
        value: 1,
        text: 'O'
      },
      {
        key: 2,
        value: 2,
        text: 'X'
      }
    ];

    const formValue = formStore && formStore.values;
    const formInitial = formStore && formStore.initial;

    return (
      <div>
        {(isModal === 'eduQuizAdd' || (isModal === 'eduQuizEdit' && formValue && formValue.eduAttachNo)) && (
          <ModalTemplate
            closeOnEscape={false}
            closeOnDimmerClick={false}
            closeOnDocumentClick={false}
            onToggleModal={onToggleModal}
            className={cx('modal-examEdit-area', 'common-content')}
            closeIcon={
              <Icon
                name="close"
                link
                onClick={() => {
                  onToggleModal('');
                }}
              />
            }
            visible
            header={
              <div className={cx('modal-custom-header')}>
                <div className={cx('modal-template-title')}>
                  {isModal === 'eduQuizAdd' ?
                    defineMessages(formatMessage({ id: 'Quiz_9', defaultMessage: '퀴즈 등록' }))
                    : defineMessages(formatMessage({ id: 'Quiz_10', defaultMessage: '퀴즈 수정' }))
                  }
                </div>
              </div>
            }
            buttons={
              <div className={cx('inline-block', 'bt-area-right')}>
                <Btn
                  buttonColor="#bbbbbb"
                  loading={loading}
                  disabled={loading}
                  onClick={() => {
                    onToggleModal('');
                  }}>
                  {defineMessages(formatMessage({ id: 'ModalEdu_1', defaultMessage: '취 소' }))}
                </Btn>
                {isModal === 'eduQuizAdd' &&
                  <Btn
                    className={cx('brand-button')}
                    buttonColor="#ffffff"
                    loading={loading}
                    disabled={loading || !formValue || (formValue && !formValue.quizContent || !formValue.quizSolution || !formValue.fileNo)}
                    onClick={postEduQuiz}>
                    {defineMessages(formatMessage({ id: 'ModalEdu_6', defaultMessage: '등 록' }))}
                  </Btn>}
                {isModal === 'eduQuizEdit' &&
                  <Btn
                    className={cx('brand-button')}
                    buttonColor="#ffffff"
                    loading={loading}
                    disabled={loading || formValue && (JSON.stringify(formValue) === JSON.stringify(formInitial) || !formValue.quizContent || !formValue.fileNo)
                    }
                    onClick={putEduQuiz}>
                    {defineMessages(formatMessage({ id: 'ModalEdu_3', defaultMessage: '수 정' }))}
                  </Btn>}
              </div>
            }>
            <div className={cx('modal-content', 'edu-edit-modal')}>
              <Loading active={loading} size="small" content={'Loading...'} />
              <div className={cx('modalEduAdd-wrapper')}>
                {/* 퀴즈 유형 */}
                {/* <div className={cx('wrapper-inner')}>
                  <span className={cx('materialTextField-title')}>
                    {defineMessages(formatMessage({ id: 'Quiz_1', defaultMessage: '퀴즈 유형' }))}
                  </span>
                  <ReduxFormSemanticDropdown
                    className={cx('eduExam-dropdown')}
                    placeholder={defineMessages(
                      formatMessage({ id: 'ModalEdu_9', defaultMessage: '퀴즈 유형을 선택하세요' })
                    )}
                    name="quizType"
                    fluid
                    // search
                    selection
                    autoFocus
                    options={quizTypeOption}
                  // onChange={handleChangeExam}
                  // defaultValue={examNoArray.get(String(selectEditEduNo))}
                  />
                </div> */}

                {/* 퀴즈 내용 */}
                <div className={cx('wrapper-inner')}>
                  <span className={cx('materialTextField-title')}>
                    {defineMessages(formatMessage({ id: 'Quiz_2', defaultMessage: '퀴즈 내용' }))}
                  </span>
                  <Field
                    className={cx('textarea-field')}
                    component="textarea"
                    name="quizContent"
                    placeholder={defineMessages(formatMessage({ id: 'ModalEdu_12', defaultMessage: '퀴즈 내용을 입력하세요' }))}
                  />
                </div>

                {/* 퀴즈 정답: 진위형일 경우 드롭다운, 선다형일 경우 텍스트 입력 */}
                <div className={cx('wrapper-inner')}>
                  <span className={cx('materialTextField-title')}>
                    {defineMessages(formatMessage({ id: 'Quiz_3', defaultMessage: '정답' }))}
                  </span>
                  <ReduxFormSemanticDropdown
                    className={cx('eduExam-dropdown')}
                    placeholder={defineMessages(
                      formatMessage({ id: 'ModalEdu_10', defaultMessage: '정답을 선택하세요' })
                    )}
                    name="quizSolution"
                    fluid
                    selection
                    autoFocus
                    options={quizSolutionOption}
                    defaultValue={formValue && formValue.quizSolution ? formValue.quizSolution : ''}
                  />
                  {/* {formValue && formValue.quizType === 1 ? (
                    <ReduxFormSemanticDropdown
                      className={cx('eduExam-dropdown')}
                      placeholder={defineMessages(
                        formatMessage({ id: 'ModalEdu_10', defaultMessage: '정답을 선택하세요' })
                      )}
                      name="quizSolution"
                      fluid
                      // search
                      selection
                      autoFocus
                      options={quizSolutionOption}
                    />
                  ) : (
                      <ReduxFormMaterialTextField
                        className={cx('materialTextfield', 'input-area')}
                        name="quizSolution"
                        checkType={101}
                        required
                      // validate={['required', 'examName']}
                      />
                    )} */}
                </div>

                {/* 컨텐츠 선택 */}
                <div className={cx('wrapper-inner')}>
                  <span className={cx('materialTextField-title')}>
                    {defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '컨텐츠' }))}
                  </span>
                  <ReduxFormSemanticDropdown
                    className={cx('eduExam-dropdown')}
                    placeholder={defineMessages(
                      formatMessage({ id: 'Edu_9', defaultMessage: '교육 컨텐츠를 선택하세요' })
                    )}
                    name="eduAttachNo"
                    fluid
                    search
                    selection
                    autoFocus
                    options={eduContentsOption}
                    onChange={handleChangeContents}
                    defaultValue={formValue && formValue.eduAttachNo ? formValue.eduAttachNo : ''}
                  />
                </div>

                {/* 퀴즈 내용 넣을 교육 영상 선택 */}
                <div className={cx('wrapper-inner')}>
                  <span className={cx('materialTextField-title')}>
                    {defineMessages(formatMessage({ id: 'Quiz_8', defaultMessage: '교육 영상' }))}
                  </span>
                  <ReduxFormSemanticDropdown
                    className={cx('eduExam-dropdown', (formValue && formValue.eduAttachNo || isModal === 'eduQuizEdit') ? '' : 'disable')}
                    placeholder={formValue && formValue.eduAttachNo ? defineMessages(
                      formatMessage({ id: 'ModalEdu_11', defaultMessage: '교육 영상을 선택하세요' })
                    ) : defineMessages(
                      formatMessage({ id: 'Edu_9', defaultMessage: '교육 컨텐츠를 선택하세요' })
                    )}
                    name="fileNo"
                    fluid
                    search
                    selection
                    autoFocus
                    options={eduFileOption}
                    defaultValue={formValue && formValue.fileNo ? formValue.fileNo : ''}
                  />
                </div>
              </div>
            </div>
          </ModalTemplate >
        )}
      </div >
    );
  }
}

const mapDispatchToProps = dispatch => ({
  EduActions: bindActionCreators(eduActions, dispatch)
});

export default connect(null, mapDispatchToProps)(
  reduxForm({
    form: 'eduQuizAddEdit',
    enableReinitialize: true,
    touchOnChange: true
  })(injectIntl(EduQuizAddEditModal)));


// WEBPACK FOOTER //
// ./src/script/components/edu/EduQuizAddEditModal.js